import React from "react";
import { CollapsePanel } from "./CollapsePanel";
import { DetailGrid, DetailGridItem } from "./DetailGrid";

export const PharmacyPracticeInfo = ({ pharmacyPracticeInfo }) => {
  return (
    <>
      <CollapsePanel labelText="Provider Info">
        <DetailGrid className="detail-grid-large">
          <DetailGridItem title="Provider Name" value={pharmacyPracticeInfo.practiceName} />
          <DetailGridItem title="Provider Npi" value={pharmacyPracticeInfo.npi} />
          <DetailGridItem title="Practice Address" value={pharmacyPracticeInfo.addressInfoSnowflake} />
          <DetailGridItem title="Practice Phone" value={pharmacyPracticeInfo.phone} />
          <DetailGridItem title="Practice Fax" value={pharmacyPracticeInfo.faxNumber} />
          <DetailGridItem title="Tax ID" value={pharmacyPracticeInfo.taxId} />
          <DetailGridItem title="Coverage Type" value={pharmacyPracticeInfo.coverageType} />
          <DetailGridItem title="Site Of Service" value={pharmacyPracticeInfo.siteService} />
        </DetailGrid>
      </CollapsePanel>
    </>
  );
};
